// @flow
import React from 'react';
import querystring from 'query-string';
import { Link } from 'react-router-dom';
import logo from '../../assets/jovi-logo.svg';
import loading from '../../assets/loading-transparent.svg';
import { Config, CognitoIdentityCredentials } from "aws-sdk";
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { Jovi } from '../../../config/DEV.json';

import './VerifyEmail.css';

Config.credentials = new CognitoIdentityCredentials({
  IdentityPoolId: Jovi.AWS.Cognito.IdentityPoolId
});

const poolData = {
  UserPoolId: Jovi.AWS.Cognito.UserPoolId,
  ClientId: Jovi.AWS.Cognito.ClientId
};
const userPool = new CognitoUserPool(poolData);

function FormErrors(props) {
  return props.errors.length > 0 ?
    <div className='FormErrors' id="errors">
      <ul>
        {props.errors.map((error, index) =>
          <li key={index}>{error}</li>
        )}
      </ul>
    </div>
    : null;
}

type VerifyEmailProps = {
  location: Location
};

export default class VerifyEmail extends React.Component {
  state: {
    isVerifying: boolean,
    isVerified: boolean,
    errors: string[],
    email: ?string,
    verificationCode: ?string
  };

  constructor(props: VerifyEmailProps) {
    super(props);
    this.state = {
      isVerifying: false,
      isVerified: false,
      errors: [],
      email: querystring.parse(props.location.search).email || null,
      verificationCode: querystring.parse(props.location.search).code || null
    }
  }

  componentWillMount = (): void => {
    if (this.state.email && this.state.verificationCode) {
      this.setState({ isVerifying: true });
      const userData = {
        Username: this.state.email,
        Pool: userPool
      };
      const cognitoUser = new CognitoUser(userData);
      cognitoUser.confirmRegistration(this.state.verificationCode, true, (err, result) => {
        this.setState({
          isVerifying: false
        });
        if (err) {
          console.log('---Verification Failure---');
          console.error(err);
          this.setState({ errors: [err.message] });
        } else {
          this.setState({
            errors: [],
            isVerified: true
          })
        }
      });
    }
  }

  render() {
    return (
      <div className='VerifyEmail'>
        <Link to='/'><img src={logo} alt='Jovi Inc.' className='RegistrationForm-logo' /></Link>
        {
          (this.state.isVerifying || this.state.isVerified) &&
          (<div className='VerifyEmail-verifying'>
            {this.state.isVerifying &&
              <img src={loading} alt='verifying email' className='VerifyEmail-verifyingImage' />
            }
            {
              this.state.isVerified &&
              <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
              </svg>
            }
            <p>{this.state.isVerified ? 'Email verified!' : 'Verifying Email...'}</p>
            {this.state.isVerified &&
              <p>Go ahead and <a href='https://admin.jovi.rocks'>login</a></p>
            }
          </div>)
        }
        <FormErrors errors={this.state.errors} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/VerifyEmail/VerifyEmail.jsx